// extracted by mini-css-extract-plugin
module.exports = {"root":"back-button_root__0Ub7_"};